module.exports = "<article>\n  <h2>Thank you for your log submission request</h2>\n  <span class=\"col-md-12 col-xs-12\">\n   <p class=\"status_update\">We have received your hydrant log details for Property Plus account. Please\n    <a href= \"mailto:technicalenquiries@gww.com.au\" class=\"underline\">email</a> or call us on 13 44 99.</p>\n</span>\n</article>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hydrant-log/log-confirmation.component.html
// module id = ./src/app/hydrant-log/log-confirmation.component.html
// module chunks = main